import JsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

export default {
  list: async (dados, title, orientation = 'portrait') => {
    moment.locale()
    var time = moment().format('LLL')
    var logoMilkPlan = new Image()
    logoMilkPlan.src = 'img/logo-pdf.png'

    var doc = new JsPDF(orientation)
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var totalPagesExp = '{total_pages_count_string}'

    doc.addImage(
      logoMilkPlan,
      'PNG',
      pageWidth - 25,
      10,
      15,
      10,
      'LogoMilkPlan',
    )

    doc.setFontSize(16)
    doc.text(title, 10, 15)

    var posX = 10
    var posY = 30
    var incrementoY = 5
    doc.setFontSize(10)
    for (let index = 0; index < dados.length; index++) {
      doc.setTextColor(100)
      doc.setFontType('normal')
      doc.text(dados[index].title, posX, posY, {maxWidth: 200})
      posY +=
        incrementoY *
        parseInt((doc.getTextWidth(dados[index].title) + 199) / 200)
      doc.setTextColor(40, 65, 106)
      doc.setFontType('bold')
      doc.text(dados[index].content || '', posX, posY)
      posY += incrementoY * 1.5
      if (posY + 10 > pageHeight && index < dados.length - 1) {
        doc.addPage()
        posY = 15
      }
    }
    posY += incrementoY

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    doc.save(title + '-' + time + '.pdf')
  },
}
